export default {
  en: {
    'DEFAULT_REPORT_NAME': 'Untitled Insight',
    'SAVE_TT': 'Save a new insight',
    'UPDATE_REPORT_TT': 'Update saved insight',
    'SAVE_AS_TT': 'Save a new insight with the same settings',
    'DELETE_TT': 'Delete this saved insight',
    'DELETE_MESSAGE': 'Are you sure you want to delete this saved insight?',
  }
};